import type { RouteObject } from 'react-router';

import { PERMISSIONS } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';
import { RequirePermission } from '@/features/auth';

export const billingRoutes: RouteObject[] = [
  {
    element: <RequirePermission permission={PERMISSIONS.INVOICES_READ} />,
    children: [
      {
        path: ROUTES.INVOICES,
        lazy: async () => ({ Component: (await import('./pages/InvoicesPage')).InvoicesPage }),
      },
    ],
  },
];
